import envValues from '../enviornment';

export const SERVER_URL = `${envValues.REACT_APP_API_ENDPOINT}/auth`;
export const SERVER_BASE_URL = envValues.REACT_APP_API_ENDPOINT;
export const SERVER_URL_WEB = envValues.REACT_APP_API_FRONT_END;
export const SERVER_URL_LANDING = envValues.REACT_APP_API_LANDING_PAGE;
export const ERROR_MESSAGE = 'Api Fetch Error!';
export const ENCRYPT_SECERET_KEY = 'armia-secret-key@123';
export const REACT_APP_API_POST_USER = `${envValues.REACT_APP_API_ENDPOINT}/user`;
export const REACT_APP_API_FETCH_USER = `${envValues.REACT_APP_API_ENDPOINT}/user?`;
export const REACT_APP_API_FETCH_VENDOR = `${envValues.REACT_APP_API_ENDPOINT}/vendor?`;
export const REACT_APP_API_FETCH_VENDOR_USERS = `${envValues.REACT_APP_API_ENDPOINT}/vendorusers/admin?`;
export const REACT_APP_API_FETCH_EMPLOYEE = `${envValues.REACT_APP_API_ENDPOINT}/employee?active=true&`;
export const REACT_APP_API_FETCH_ROLE = `${envValues.REACT_APP_API_ENDPOINT}/roles?active=true&`;
export const REACT_APP_API_SKILLS = `${envValues.REACT_APP_API_ENDPOINT}/dummy/selectdata`;
export const REACT_APP_API_ROLES_DROPDOWN = `${envValues.REACT_APP_API_ENDPOINT}/roles/select`;
export const REACT_APP_API_FETCH_MOVIES = `${envValues.REACT_APP_API_ENDPOINT}/movies?active=true&`;
export const REACT_APP_API_FETCH_NOTIFICATIONS = `${envValues.REACT_APP_API_ENDPOINT}/notifications?`;
export const REACT_APP_API_FETCH_EVENT = `${envValues.REACT_APP_API_ENDPOINT}/event/past-events?`;
export const REACT_APP_API_FETCH_MANAGERS = `${envValues.REACT_APP_API_ENDPOINT}/manager?`;
export const REACT_APP_API_FETCH_ATTENDEES = `${envValues.REACT_APP_API_ENDPOINT}/attendee?`;
export const REACT_APP_API_FETCH_ITEMS = `${envValues.REACT_APP_API_ENDPOINT}/items?`;
export const REACT_APP_API_FETCH_TRANSFER = `${envValues.REACT_APP_API_ENDPOINT}/transfer?`;
export const REACT_APP_API_FETCH_EVENT_VENDORS = `${envValues.REACT_APP_API_ENDPOINT}/eventdashboard/vendors?`;
export const REACT_APP_API_FETCH_APPUPDATES = `${envValues.REACT_APP_API_ENDPOINT}/appupdate?`;
export const REACT_APP_API_FETCH_SUPPORT = `${envValues.REACT_APP_API_ENDPOINT}/support?`;
export const REACT_APP_API_FETCH_SHOWS = `${envValues.REACT_APP_API_ENDPOINT}/shows/admin?`;
export const REACT_APP_API_FETCH_PENDING_SHOWS = `${envValues.REACT_APP_API_ENDPOINT}/shows/pending-shows`;
export const REACT_APP_API_SHOW_STATUS = (showId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/shows/status/${showId}`;
export const REACT_APP_API_BULK_UPDATE_SHOWS_STATUS = `${envValues.REACT_APP_API_ENDPOINT}/shows/bulk-update-status`;
export const REACT_APP_API_GET_SHOW_ADMIN = (eventId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/shows/admin/${eventId}`;
export const REACT_APP_API_ADMIN_UPLOAD_SEAT_MAP = (eventId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/shows/admin/${eventId}/seat-map`;
export const REACT_APP_API_FETCH_BOOKED_USERS = `${envValues.REACT_APP_API_ENDPOINT}/shows/bookings-web`;
export const REACT_APP_API_FETCH_CMS = `${envValues.REACT_APP_API_ENDPOINT}/cms?`;
export const REACT_APP_API_FETCH_AUDIT_LOGS = `${envValues.REACT_APP_API_ENDPOINT}/auditlogs`;
export const REACT_APP_API_FETCH_MANAGER_PROFILES = `${envValues.REACT_APP_API_ENDPOINT}/user/managerProfiles`;
export const REACT_APP_API_CREATE_MANAGER = `${envValues.REACT_APP_API_ENDPOINT}/user/manager`;
export const REACT_APP_API_GET_MANAGER_DETAILS = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}`;
export const REACT_APP_API_MANAGER_ACTIVE_EVENTS = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/active-events`;
export const REACT_APP_API_MANAGER_ONBOARD = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/onboard`;
export const REACT_APP_API_MANAGER_PAYMENT_METHODS = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/payment-methods`;
export const REACT_APP_API_MANAGER_BUSINESS_DETAILS = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/business-details`;
export const REACT_APP_API_GOOGLE_AUTOCOMPLETE = `${envValues.REACT_APP_API_ENDPOINT}/google/auto-complete`;
export const REACT_APP_API_MANAGER_SUSPEND = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/suspend`;
export const REACT_APP_API_MANAGER_REVOKE = (managerId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/revoke`;
export const REACT_APP_API_VERIFY_MANAGER_DOC = (managerId, docIndex) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/verification-documents/${docIndex}/verify`;
export const REACT_APP_API_REJECT_MANAGER_DOC = (managerId, docIndex) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/verification-documents/${docIndex}/reject`;
export const REACT_APP_API_DOWNLOAD_MANAGER_DOC = (managerId, docIndex) =>
  `${envValues.REACT_APP_API_ENDPOINT}/user/manager/${managerId}/verification-documents/${docIndex}/download`;

export const REACT_APP_API_REFUND_REQUESTS = `${envValues.REACT_APP_API_ENDPOINT}/refundrequests`;
export const REACT_APP_API_REFUND_APPROVE = (ticketId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/refundrequests/${ticketId}/approve`;
export const REACT_APP_API_REFUND_REJECT = (ticketId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/refundrequests/${ticketId}/reject`;
export const REACT_APP_API_REFUND_BULK_APPROVE = `${envValues.REACT_APP_API_ENDPOINT}/refundrequests/bulk-approve`;
export const REACT_APP_API_REFUND_BULK_REJECT = `${envValues.REACT_APP_API_ENDPOINT}/refundrequests/bulk-reject`;

export const REACT_APP_API_PRICING_AUDIT = `${envValues.REACT_APP_API_ENDPOINT}/pricingaudit`;
export const REACT_APP_API_PRICING_AUDIT_APPROVE = (ticketId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/pricingaudit/${ticketId}/approve`;
export const REACT_APP_API_PRICING_AUDIT_FLAG = (ticketId) =>
  `${envValues.REACT_APP_API_ENDPOINT}/pricingaudit/${ticketId}/flag`;
export const REACT_APP_API_PRICING_AUDIT_BULK_APPROVE = `${envValues.REACT_APP_API_ENDPOINT}/pricingaudit/bulk-approve`;

export const REACT_APP_API_PLATFORM_COUNTERS = `${envValues.REACT_APP_API_ENDPOINT}/platformanalysis/counters`;
export const REACT_APP_API_PLATFORM_REVENUE_GRAPH = `${envValues.REACT_APP_API_ENDPOINT}/platformanalysis/revenue-graph`;
export const REACT_APP_API_PLATFORM_TICKET_SALES_GRAPH = `${envValues.REACT_APP_API_ENDPOINT}/platformanalysis/ticket-sales-graph`;
export const REACT_APP_API_PLATFORM_USER_GROWTH = `${envValues.REACT_APP_API_ENDPOINT}/platformanalysis/user-growth-trends`;
export const REACT_APP_API_PLATFORM_TOKEN_VOLUME = `${envValues.REACT_APP_API_ENDPOINT}/platformanalysis/token-transfer-volume`;
